import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";
import CategoryPage from "./pages/catalog/CategoryPage";
import SectionPage from "./pages/catalog/SectionPage";
import GarmentDesignsPage from "./pages/catalog/GarmentDesignsPage";
import UploadDesignPage from "./pages/catalog/UploadDesignPage";
import AiDesignPage from "./pages/catalog/AiDesignPage";
import DesignConfirmationPage from "./pages/catalog/DesignConfirmationPage";
import MeasurementsPage from "./pages/catalog/MeasurementsPage";
import GarmentDetailPage from "./pages/catalog/GarmentDetailPage";
import DesignDetailPage from "./pages/catalog/DesignDetailPage";
import ManualMeasurementsPage from "./pages/catalog/ManualMeasurementsPage";
import SavedMeasurementsPage from "./pages/catalog/SavedMeasurementsPage";
import HomeMeasurementPage from "./pages/catalog/HomeMeasurementPage";
import FabricSelectionPage from "./pages/catalog/FabricSelectionPage";
import AddOnsPage from "./pages/catalog/AddOnsPage";
import PickupDeliveryPage from "./pages/catalog/PickupDeliveryPage";
import OrderSummaryPage from "./pages/catalog/OrderSummaryPage";
import CheckoutPage from "./pages/catalog/CheckoutPage";
import WorkflowLandingPage from "./pages/workflows/WorkflowLandingPage";
import WorkflowItemsPage from "./pages/workflows/WorkflowItemsPage";
import ScrollToHash from "./components/site/ScrollToHash";
import LegalPage from "./pages/LegalPage";
import WorkflowBookingPage from "./pages/workflows/WorkflowBookingPage";
import WorkflowPaymentPage from "./pages/workflows/WorkflowPaymentPage";
import AlterationServicesPage from "./pages/alterations/AlterationServicesPage";
import AlterationDetailsPage from "./pages/alterations/AlterationDetailsPage";
import AlterationPickupPage from "./pages/alterations/AlterationPickupPage";
import AlterationReviewPage from "./pages/alterations/AlterationReviewPage";
import AlterationCheckoutPage from "./pages/alterations/AlterationCheckoutPage";
import AlterationGarmentsPage from "./pages/alterations/AlterationGarmentsPage";
import AlterationOrderBuilderPage from "./pages/alterations/AlterationOrderBuilderPage";
import AlterationGarmentDetailsPage from "./pages/alterations/AlterationGarmentDetailsPage";
import FabricFlowPage from "./pages/fabric/FabricFlowPage";
import ServiceCategoriesPage from "./pages/ServiceCategoriesPage";
import AuthGate from "./components/auth/AuthGate";
import CustomerProfilePage from "./pages/CustomerProfilePage";
import ProductDetailsPage from "./pages/workflows/ProductDetailsPage";
import CustomerCenterPage from "./pages/CustomerCenterPage";
import OrderDetailsPage from "./pages/OrderDetailsPage";
import ProfileFeaturePage from "./pages/ProfileFeaturePage";
import SearchPage from "./pages/SearchPage";
import InspirationPage from "./pages/InspirationPage";
import HomeMeasurementBookingPage from "./pages/HomeMeasurementBookingPage";
import DryCleaningDetailsPage from "./pages/drycleaning/DryCleaningDetailsPage";
import DryCleaningBasketPage from "./pages/drycleaning/DryCleaningBasketPage";
import MaterialCartPage from "./pages/materials/MaterialCartPage";
import MachineServiceBookingPage from "./pages/machine/MachineServiceBookingPage";
import StitchingLivePrice from "./components/pricing/StitchingLivePrice";
import CostumeRentalsPage from "./pages/costumes/CostumeRentalsPage";
import NotificationsPage from "./pages/NotificationsPage";
import CelebrityDesignsPage from "./pages/celebrity/CelebrityDesignsPage";
import CelebrityDesignDetailPage from "./pages/celebrity/CelebrityDesignDetailPage";
import TailorQuoteDetailsPage from "./pages/TailorQuoteDetailsPage";
import SpecialStitchingPage from "./pages/SpecialStitchingPage";
import TailorAssistedOrderPage from "./pages/TailorAssistedOrderPage";
import EssentialsContentPage from "./pages/EssentialsContentPage";
import BlogPage from "./pages/BlogPage";
import ComingSoonPage from "./pages/ComingSoonPage";

function App() {
  return (
    <AuthGate><div className="App min-h-screen bg-[#F9F8F6] text-[#1A1A1A]">
      <BrowserRouter>
        <ScrollToHash />
        <StitchingLivePrice />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<LegalPage type="privacy" />} />
          <Route path="/terms" element={<LegalPage type="terms" />} />
          <Route path="/services" element={<ServiceCategoriesPage />} />
          <Route path="/services/special-stitching" element={<SpecialStitchingPage />} />
          <Route path="/upload-design" element={<Navigate to="/category/celebrity/section/designs/item/stitching_my_design/upload-design" replace />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/customised-bridal-dresses" element={<EssentialsContentPage type="accolades" />} />
          <Route path="/services/tailor-assisted" element={<TailorAssistedOrderPage />} />
          <Route path="/profile" element={<CustomerProfilePage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/profile/:feature" element={<ProfileFeaturePage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/inspiration" element={<InspirationPage />} />
          <Route path="/inspiration/:inspirationId" element={<InspirationPage />} />
          <Route path="/celebrity-designs" element={<CelebrityDesignsPage />} />
          <Route path="/celebrity-designs/:designId" element={<CelebrityDesignDetailPage />} />
          <Route path="/services/home-measurement" element={<HomeMeasurementBookingPage />} />
          <Route path="/services/fabric-store" element={<ComingSoonPage serviceKey="fabric_store" serviceName="Fabric Store" />} />
          <Route path="/services/materials" element={<ComingSoonPage serviceKey="materials" serviceName="Materials Store" />} />
          <Route path="/services/dry-cleaning/basket" element={<DryCleaningBasketPage />} />
          <Route path="/services/materials/cart" element={<ComingSoonPage serviceKey="materials" serviceName="Materials Store" />} />
          <Route path="/services/costume-rentals" element={<ComingSoonPage serviceKey="costume_rentals" serviceName="Costume Rentals" />} />
          <Route path="/services/machine-services/:groupId/:itemId/booking" element={<MachineServiceBookingPage />} />
          <Route path="/services/dry-cleaning/:groupId/:itemId/details" element={<DryCleaningDetailsPage />} />
          <Route path="/account/:section" element={<CustomerCenterPage />} />
          <Route path="/account/orders/:orderId" element={<OrderDetailsPage />} />
          <Route path="/account/quotes/:requestId" element={<TailorQuoteDetailsPage />} />
          <Route path="/category/:categoryId" element={<CategoryPage />} />
          <Route path="/services/:workflow" element={<WorkflowLandingPage />} />
          <Route path="/services/:workflow/:groupId" element={<WorkflowItemsPage />} />
          <Route path="/services/alterations/build" element={<AlterationOrderBuilderPage />} />
          <Route path="/services/alterations/build/garment-details" element={<AlterationGarmentDetailsPage />} />
          <Route path="/services/fabric-store/:groupId/:itemId/:step" element={<FabricFlowPage />} />
          <Route path="/services/:workflow/:groupId/:itemId/details" element={<ProductDetailsPage />} />
          <Route path="/services/alterations/:groupId/garments" element={<AlterationGarmentsPage />} />
          <Route path="/services/alterations/:groupId" element={<AlterationServicesPage />} />
          <Route path="/services/alterations/:groupId/details" element={<AlterationDetailsPage />} />
          <Route path="/services/alterations/:groupId/pickup" element={<AlterationPickupPage />} />
          <Route path="/services/alterations/:groupId/review" element={<AlterationReviewPage />} />
          <Route path="/services/alterations/:groupId/checkout" element={<AlterationCheckoutPage />} />
          <Route path="/services/:workflow/:groupId/:itemId/booking" element={<WorkflowBookingPage />} />
          <Route path="/services/:workflow/:groupId/:itemId/payment" element={<WorkflowPaymentPage />} />
          <Route path="/category/:categoryId/section/:sectionId" element={<SectionPage />} />
          <Route path="/category/:categoryId/section/:sectionId/subsection/:subsectionId" element={<SectionPage />} />
          <Route path="/category/:categoryId/section/:sectionId/item/:garmentId" element={<GarmentDetailPage />} />
          <Route path="/category/:categoryId/section/:sectionId/item/:garmentId/designs" element={<GarmentDesignsPage />} />
          <Route path="/category/:categoryId/section/:sectionId/item/:garmentId/design/:designId" element={<DesignDetailPage />} />
          <Route path="/category/:categoryId/section/:sectionId/item/:garmentId/design-confirmation" element={<DesignConfirmationPage />} />
          <Route path="/category/:categoryId/section/:sectionId/item/:garmentId/measurements" element={<MeasurementsPage />} />
          <Route path="/category/:categoryId/section/:sectionId/item/:garmentId/measurements/manual" element={<ManualMeasurementsPage />} />
          <Route path="/category/:categoryId/section/:sectionId/item/:garmentId/measurements/saved" element={<SavedMeasurementsPage />} />
          <Route path="/category/:categoryId/section/:sectionId/item/:garmentId/measurements/home" element={<HomeMeasurementPage />} />
          <Route path="/category/:categoryId/section/:sectionId/item/:garmentId/fabric" element={<FabricSelectionPage />} />
          <Route path="/category/:categoryId/section/:sectionId/item/:garmentId/add-ons" element={<AddOnsPage />} />
          <Route path="/category/:categoryId/section/:sectionId/item/:garmentId/pickup-delivery" element={<PickupDeliveryPage />} />
          <Route path="/category/:categoryId/section/:sectionId/item/:garmentId/order-summary" element={<OrderSummaryPage />} />
          <Route path="/category/:categoryId/section/:sectionId/item/:garmentId/checkout" element={<CheckoutPage />} />
          <Route path="/category/:categoryId/section/:sectionId/item/:garmentId/ai-design" element={<AiDesignPage />} />
          <Route path="/category/:categoryId/section/:sectionId/item/:garmentId/upload-design" element={<UploadDesignPage />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div></AuthGate>
  );
}

export default App;
